module.exports = __webpack_public_path__ + "img/288w.beba91b.jpg";